import axios from "axios";
import API_URL from "../config/apiConfig";

export const requestOtp = (phone) =>
  axios
    .post(`${API_URL}/api/auth/restaurant/otp/request`, { phone })
    .then(({ data }) => data);

export const verifyOtp = (phone, code, rememberMe) =>
  axios
    .post(`${API_URL}/api/auth/restaurant/otp/verify`, { phone, code, rememberMe })
    .then(({ data }) => data);

export const completeProfile = (registrationToken, profile, rememberMe) =>
  axios
    .post(`${API_URL}/api/auth/restaurant/complete-profile`, { ...profile, rememberMe }, {
      headers: { Authorization: `Bearer ${registrationToken}` },
    })
    .then(({ data }) => data);
